import React, { Component } from 'react';
import { Tooltip, Icon } from 'antd';
import UserSider from '../UserSider';
import Personal from './Personal';
import Team from './Team';

class UserEfficiency extends Component {
    state = {
        cur: 'personal',
    }

    handleBtnClick = (cur) => {
        this.setState({ cur });
    }

    render() {
        const { cur } = this.state;
        return (
            <div className="content">
                <UserSider selectKey="userEfficiency" openKeys={['sub2']}/>
                <div className="main">
                    <div className="main-content">
                        <div className="tab_flex">
                            <a onClick={() => this.handleBtnClick('personal')} className={cur == 'personal' ? 'curr' : ''} >
                                个人效率
                                <Tooltip overlayStyle={{ width: 210, wordBreak: 'break-all' }} placement="top" title={'统计个人在项目上担任PM/PA/CRC/CRCC产生的项目确认FTE'}>
                                    <Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" />
                                </Tooltip>
                            </a>
                            <a onClick={() => this.handleBtnClick('team')} className={cur == 'team' ? 'curr' : ''} >
                                团队效率
                                <Tooltip overlayStyle={{ width: 218, wordBreak: 'break-all' }} placement="top" title={'统计团队下人员在项目上担任PM/PA/CRC/CRCC产生的项目确认FTE'}>
                                    <Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" />
                                </Tooltip>
                            </a>
                        </div>
                        { cur === 'personal' && <Personal /> }
                        { cur === 'team' && <Team /> }
                    </div>
                </div>
            </div>
        );
    }
}

export default UserEfficiency;


// WEBPACK FOOTER //
// ./src/components/user/userEfficiency/index.js